import React from 'react';

const DismissScheduler = (props: {onClick: () => void}) => {
	return <div className="border rounded-3xl mx-4">
		<button className="py-[16px] w-full pl-4 flex items-center text-center text-gray-400 text-xs"
		        onClick={props.onClick}>
			<div className="mr-2">Don't want to book an appointment? <span
				className="text-primary">Return to chat</span></div>
		</button>
	</div>;
};

export default DismissScheduler;
